export default "__VITE_ASSET__BwqP7N3l__"